export const locale = {
    lang: 'en',
    data: {
        MONDAY_SHORT: 'Mon',
        TUESDAY_SHORT: 'Tue',
        WEDNESDAY_SHORT: 'Wed',
        THURSDAY_SHORT: 'Thu',
        FRIDAY_SHORT: 'Fri',
        HISTORY: {
            MEDIC_HISTORY: 'Complete history',
            EVO_NOTE: 'Evolutive note',
            PENDING: 'Pending',
            RESCHEDULE: 'Reschedule',
        },
        MONTH: {
            JANUARY: 'January',
            FREBRUARY: 'February',
            MARCH: 'March',
            APRIL: 'April',
            MAY: 'May',
            JUNE: 'June',
            JULY: 'July',
            AUGUST: 'August',
            SEPTEMBER: 'September',
            OCTOBER: 'October',
            NOVEMBER: 'November',
            DECEMBER: 'December',
        },
    },
};
